export async function wait(ms) {
    return await new Promise(resolve => setTimeout(resolve, ms));
}

// Collapses calls made while an identical request is still in flight. The entry is dropped once the
// request settles, so a later call always asks again - this deduplicates, it does not cache.
export function createRequestDeduplicator() {
    const inFlight = {};

    return function deduplicate(key, sendRequest) {
        if (inFlight[key]) {
            return inFlight[key];
        }

        const request = sendRequest().finally(() => {
            delete inFlight[key];
        });

        inFlight[key] = request;

        return request;
    };
}